import { Users, Shield, Sparkles, Flame } from "lucide-react";
import { STATS, TIMELINE, VALUES, IMAGES } from "@/data/content";
import { useReveal } from "@/hooks/useReveal";

const ICONS = { Users, Shield, Sparkles, Flame };

export function About() {
  const head = useReveal();
  return (
    <section id="histoire" data-testid="about-history-section" className="relative py-20 md:py-28 bg-ink">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div ref={head.ref} className={head.className}>
          <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-emerald-bright mb-3">Notre ADN</p>
          <h2 className="font-display font-bold text-3xl md:text-5xl tracking-tight max-w-3xl">
            Bien plus qu'une école. <span className="text-mustard">Une famille.</span>
          </h2>
          <p className="mt-5 max-w-2xl text-cream/70 leading-relaxed">
            L'Association des Jeunes Danseurs de Rue est née à Albi en 1996. Depuis, elle
            rassemble un écosystème unique : 2 salles de danse, 1 studio d'enregistrement,
            1 graff park et 1 café hip-hop. Un refuge où chaque jeune peut trouver sa place.
          </p>
        </div>

        {/* stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-12">
          {STATS.map((s, i) => (
            <div key={i} data-testid={`stat-${i}`} className="glass rounded-2xl p-6 text-center card-hover">
              <div className="font-display font-black text-3xl md:text-4xl text-mustard">{s.value}</div>
              <div className="mt-2 font-mono2 text-[11px] uppercase tracking-wider text-cream/50">{s.label}</div>
            </div>
          ))}
        </div>

        {/* values */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mt-8">
          {VALUES.map((v, i) => {
            const Icon = ICONS[v.icon];
            return (
              <div key={i} data-testid={`value-${i}`} className="rounded-2xl p-6 bg-ink-2 border border-white/5 card-hover">
                <div className="w-11 h-11 rounded-xl bg-mustard/15 flex items-center justify-center mb-4">
                  <Icon className="w-5 h-5 text-mustard" />
                </div>
                <h3 className="font-sub font-semibold text-lg text-cream">{v.title}</h3>
                <p className="mt-2 text-sm text-cream/60 leading-relaxed">{v.text}</p>
              </div>
            );
          })}
        </div>

        {/* timeline */}
        <div className="mt-20 grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5 relative rounded-3xl overflow-hidden min-h-[320px] lg:sticky lg:top-28">
            <img src={IMAGES.stageGroup} alt="Scène AJDR" className="w-full h-full object-cover absolute inset-0" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
            <div className="absolute bottom-0 p-6">
              <p className="font-display font-black text-2xl text-cream">30 ans<br /><span className="text-mustard">de mouvement</span></p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <ol className="relative border-l border-white/10 ml-2">
              {TIMELINE.map((t, i) => (
                <li key={i} data-testid={`timeline-${i}`} className="ml-6 pb-9 last:pb-0">
                  <span className="absolute -left-[9px] w-4 h-4 rounded-full bg-mustard ring-4 ring-ink" />
                  <span className="font-mono2 text-sm text-emerald-bright">{t.year}</span>
                  <h3 className="font-sub font-semibold text-xl text-cream mt-1">{t.title}</h3>
                  <p className="mt-1.5 text-sm text-cream/60 leading-relaxed max-w-lg">{t.text}</p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
